export default {
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: 'Africa/Tripoli',
      });
    },
  },
};
